/**
 * Cashflow Cdn
 *
 * Added: Nov 1, 2022
 *
 * */

// Globals: jQuery, cashflow, WindowUtilities
import { defineCustomElements } from '@cashflow/cashflow-components/dist/esm/loader';
import { applyPolyfills } from '@cashflow/cashflow-components/dist/esm/polyfills';

function Cashflow() {
    this.accountId = window.location && window.location.host ? window.location.host.split('.')[0] : false;
    this.init();
}

Cashflow.prototype = {
    init() {
        applyPolyfills().then(() => {
            defineCustomElements(window);
        });
    },


};

const caCashflow = new Cashflow();
caCashflow.init();